import React from 'react';
import PropTypes from 'prop-types';

import '../styles/VerticalSelectMenu.css';
import { convertPlusMinus } from '../helpers/helperFunctions.js';

const VerticalSelectMenu = ({ name, settings, title, parentName, index, }) => (
    <div className="Select-container">
      <div className="Select-titles-container">
        {parentName !== undefined
          ? <><div className="Select-title-parent">{parentName}</div><div className="Select-title-item">{name}</div></>
          : <div className="Select-title-item">{name}</div>}
      </div>
      <div className="Options-container">
        {title}
        <div className="Select-item">{convertPlusMinus(settings[index])}</div>
      </div>
    </div>
  );
  
VerticalSelectMenu.propTypes = {
  name: PropTypes.string.isRequired,
  settings: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  parentName: PropTypes.string,
  index: PropTypes.number,
};

export default VerticalSelectMenu;